import type {
  Venue,
  Event,
  CreateVenueInput,
  UpdateVenueInput,
  VenueContactEntry,
  AddVenueContactInput,
  UpdateVenueContactInput,
} from '@peles/shared';
import { apiClient } from './client';

export async function listVenues(filters?: {
  isActive?: boolean;
  city?: string;
}): Promise<Venue[]> {
  const params = new URLSearchParams();
  if (filters?.isActive !== undefined) params.set('isActive', String(filters.isActive));
  if (filters?.city) params.set('city', filters.city);

  const { data } = await apiClient.get<Venue[]>('/venues', { params });
  return data;
}

export async function getVenue(id: string): Promise<Venue> {
  const { data } = await apiClient.get<Venue>(`/venues/${id}`);
  return data;
}

export async function createVenue(input: CreateVenueInput): Promise<Venue> {
  const { data } = await apiClient.post<Venue>('/venues', input);
  return data;
}

export async function updateVenue(id: string, updates: UpdateVenueInput): Promise<Venue> {
  const { data } = await apiClient.patch<Venue>(`/venues/${id}`, updates);
  return data;
}

export async function deactivateVenue(id: string): Promise<Venue> {
  const { data } = await apiClient.delete<Venue>(`/venues/${id}`);
  return data;
}

export async function listVenueEvents(venueId: string): Promise<Event[]> {
  const { data } = await apiClient.get<Event[]>(`/venues/${venueId}/events`);
  return data;
}

// ─── Venue Contacts ─────────────────────────────────────────────────────────

export async function listVenueContacts(venueId: string): Promise<VenueContactEntry[]> {
  const { data } = await apiClient.get<VenueContactEntry[]>(`/venues/${venueId}/contacts`);
  return data;
}

export async function addVenueContact(
  venueId: string,
  input: AddVenueContactInput,
): Promise<VenueContactEntry> {
  const { data } = await apiClient.post<VenueContactEntry>(`/venues/${venueId}/contacts`, input);
  return data;
}

export async function updateVenueContact(
  venueId: string,
  contactId: string,
  updates: UpdateVenueContactInput,
): Promise<VenueContactEntry> {
  const { data } = await apiClient.patch<VenueContactEntry>(
    `/venues/${venueId}/contacts/${contactId}`,
    updates,
  );
  return data;
}

export async function removeVenueContact(venueId: string, contactId: string): Promise<void> {
  await apiClient.delete(`/venues/${venueId}/contacts/${contactId}`);
}
